import {
  ContentNugget,
  NUGGET_VARIANTS,
  NuggetCard,
  mapNuggetToCardData,
} from '@backrs_ui/common-ui';

import { getCareerPathIcon } from '@backrs_ui/grow-ui/src/pages/CareerPath/util';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { useNuggetCardActions } from './useNuggetCardActions';

type NuggetCardItemProps = Readonly<{
  nugget: ContentNugget;
  onClick: (nugget: ContentNugget) => void;
  hideActions?: boolean;
  isHighlighted?: boolean;
  fluid?: boolean;
}>;

export const NuggetCardItem = ({
  nugget,
  onClick,
  hideActions,
  isHighlighted,
  fluid,
}: NuggetCardItemProps) => {
  const { careerCategories } = useAppSelector((state) => state.careerPath);
  const actions = useNuggetCardActions(nugget);

  const careerPathIconResolved =
    nugget.variant === 'career-path' && nugget.career_path_info && careerCategories.length > 0
      ? getCareerPathIcon(careerCategories, nugget.career_path_info)
      : undefined;

  const cardData = mapNuggetToCardData({
    nugget,
    careerPathIcon: careerPathIconResolved,
    predominantDegreeCode: nugget.college_info?.predominant_degree_code,
  });

  const id = `nugget-card-${nugget.variant}-${nugget.id}`;

  return (
    <NuggetCard
      id={id}
      imageUrl={cardData.imageUrl}
      isVideo={cardData.isVideo}
      title={cardData.title}
      badge={cardData.badge}
      entityName={cardData.entityName}
      featuredIcon={cardData.featuredIcon}
      description={cardData.description}
      meshConfig={cardData.meshConfig}
      onClick={() => onClick(nugget)}
      actions={hideActions ? undefined : actions}
      isHighlighted={isHighlighted}
      showEntityChip={nugget.variant === NUGGET_VARIANTS.INTERNSHIP}
      fluid={fluid}
    />
  );
};
